<template>
    <LoginComponent />
</template>
  
<script>
import LoginComponent from '../components/LoginComponent.vue';

export default {
    components: {
        LoginComponent
    },
    mounted() {
        document.body.style.backgroundColor = 'var(--bs-body-bg)';
    },
    beforeUnmount() {
        document.body.style.backgroundColor = '';
    }
};
</script>
  